/* This file is autogenerated, see readme.md for instructions */
import RuleLabelSvgIcon from '@bloomreach/banana-theme/icons/rule-label.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RuleLabelIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RuleLabelSvgIcon />
    </Icon>
  );
});

RuleLabelIcon.displayName = 'RuleLabelIcon';

export default RuleLabelIcon;
